@if (!isTabActive) {
  <div class="overlay">
    <div class="message">
      Access Denied. Please return to the tab to continue.
    </div>
  </div>
}